// One admission rule shared by both Design layouts and the order editor.
export function offlineEditContext(order, group) {
  return order?.desktop_sync?.edit_protocol === 2
    ? { protocol: 2, expected: order.desktop_sync.edit_heads?.[group] || null,
      ...(Number.isSafeInteger(order.desktop_sync.edit_base_sequence) ? { base_sequence: order.desktop_sync.edit_base_sequence } : {}) } : undefined;
}

export function pendingBlocksDesign(order) {
  const sync = order?.desktop_sync;
  if (!sync?.pending_mutation) return !!sync?.pending_delete;
  if (sync.edit_protocol !== 2 || !Array.isArray(sync.pending_mutations)) return true;
  return !!sync.pending_delete || sync.pending_mutations.some(row =>
    row.operation_type !== 'cloud_order_field_edit' || row.field_group !== 'recipient');
}

// Printing retains the established policy: unresolved Review values do not
// silently become approved names/addresses on customer-facing paperwork.
export function orderForOperationalUse(order) {
  const sync = order?.desktop_sync;
  if (sync?.edit_protocol !== 2 || !sync.confirmed_values) return order;
  const result = { ...order };
  for (const proposal of sync.pending_mutations || []) {
    if (!proposal.review_required && ['pending_sync', 'failed_retryable'].includes(proposal.state)) continue;
    for (const key of Object.keys(proposal.local_patch || {})) {
      if (Object.prototype.hasOwnProperty.call(sync.confirmed_values, key)) result[key] = sync.confirmed_values[key];
    }
  }
  return result;
}

export function printUsesConfirmedValues(order) {
  const confirmed = orderForOperationalUse(order);
  return Object.keys(order || {}).some(key => confirmed?.[key] !== order[key]);
}
